<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="flex field-value">
      <a v-if="renderValue" :href="renderValue" target="_blank" class="link">{{ renderValue }}</a>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>
import { getDynamicRender } from '@/plugins/localize'
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    documentValue: {
      type: Object,
      required: true,
    },
  },
  computed: {
    renderValue() {
      const pattern = this.question?.config?.value || ''
      return getDynamicRender(pattern, this.documentValue)
    },
  },
}
</script>
